import moment from 'moment';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import MainPagetitle from '../../../layouts/MainPagetitle';
import ActivityLogs from '../Grievance/components/ActivityLogs';
import ComplaintDetails from '../Grievance/components/ComplaintDetails';
import GrievanceHeaderInfo from '../Grievance/components/GrievanceHeaderInfo';
import ResolutionBlock from '../Grievance/components/ResolutionBlock';

const EscalatedComplaintsView = (props) => {
  const isReadonly = props.urlparams.params.readonly === 'true' ? true : false;
  const backLink = "/app/escalatedcomplaints";
  const navigate = useNavigate();
  const [complaintData, setComplaintData] = useState({});

  const handleSubmit = (e, data) => {
    console.log({ data });
    let payload = {
      resolutionRemark: data?.resolutionRemark,
    };
    props.apis.apiUpdateComplaintById(payload, { id: complaintData?.complaintId }).then((res) => {
      if (res) {
        console.log(res);
        toast.success('Complaint resolved successfully.');
        navigate(backLink);
      }
    });
  };

  const handleCloseResolution = (e) => {
    e.preventDefault();
    swal2
      .fire({
        title: 'Are you sure want to close this resolution?',
        icon: 'info',
        iconColor: '#DE3232',
        showCancelButton: true,
        confirmButtonColor: '#DE3232',
        cancelButtonColor: '##D6DBE7',
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
      })
      .then((result) => {
        if (result.isConfirmed) {
          let payload = {
            status: _enum.COMPLAINT_STATUS_MAP.CLOSED,
          };
          props.apis
            .apiUpdateComplaintById(payload, { id: complaintData?.complaintId })
            .then((res) => {
              if (res) {
                toast.success('Complaint closed successfully.');
                navigate(backLink);
              }
            });
        }
      });
  };

  const getBreadCums = () => {
    let pagetitle = complaintData?.complaintNumber || props?.urlparams?.params?.id || '';
    return pagetitle;
  };

  useEffect(() => {
    if (props?.urlparams?.params?.id) {
      props.apis.apiGetComplaintById({ id: props?.urlparams?.params?.id }).then((res) => {
        setComplaintData(res || {});
      });
    }
  }, []);

  const getAssignedTo = () => {
    if (complaintData?.assignedGrievanceStaff?.name) {
      return `${complaintData.assignedGrievanceStaff.name} (Grievance Officer)`;
    }
    if (complaintData?.assignedComplianceOfficer?.name) {
      return `${complaintData.assignedComplianceOfficer.name} (Compliance Officer)`;
    }
    if (complaintData?.assignedNodalOfficer?.name) {
      return `${complaintData.assignedNodalOfficer.name} (Nodal Officer)`;
    }
    if (complaintData?.assignedDataEntry?.name) {
      return `${complaintData.assignedDataEntry.name} (Data Entry)`;
    }
    return '-';
  };

  const headerInfoProps = {
    grievanceId: complaintData?.complaintNumber || complaintData?.complaintId || '-',
    // type: complaintData?.queryType || '-',
    receivedOn: complaintData?.createdAt
      ? moment(complaintData.createdAt).format('DD-MM-YYYY, hh:mm A')
      : '-',
    escalatedOn: complaintData?.escalatedToGrievanceAt
      ? moment(complaintData.escalatedToGrievanceAt).format('DD-MM-YYYY, hh:mm A')
      : null,
    sla: complaintData?.slaText || null,
    customerName: complaintData?.customerName || '-',
    customerPhone: complaintData?.mobileNumber || '-',
    customerLan: complaintData?.loanAccountNumber || '-',
    assignedTo: getAssignedTo(),
    previouslyAssignedTo:
      complaintData?.previousComplianceOfficer && complaintData.previousComplianceOfficer !== '-'
        ? complaintData.previousComplianceOfficer
        : null,
    assignedOn: complaintData?.assignedAt
      ? moment(complaintData.assignedAt).format('DD-MM-YYYY, hh:mm A')
      : null,
    // currentStage: complaintData?.status ? complaintData.status.toTitleCase() : '-',
    pdfUrl: null,
  };

  const complaintDetailsProps = {
    category:
      _enum?.CATEGORY_OF_SERVICE_LIST_REVERSE_MAP?.[complaintData?.categoryOfService] ||
      complaintData?.categoryOfService ||
      '-',
    title: complaintData?.complaintTitle || '-',
    explanation: complaintData?.complaintExplanation || '-',
    attachments: complaintData?.attachments || [],
  };

  const mappedLogs = (complaintData?.logs || [])
    .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
    .map((log) => ({
      ...log,
      timestamp: log?.createdAt ? moment(log.createdAt).format('DD MMM YYYY, hh:mm A') : '-',
      actionType: log?.actionType || '-',
      actionBy: log?.actionByName || log?.actionBy || '-',
      actionDetails: log?.actionDetails || '-',
    }));

  return (
    <>
      <MainPagetitle
        mainTitle="Escalated Complaints"
        back={getBreadCums()}
        backLink={backLink}
        pageIcon={imagepaths.GrievanceIconActive}
      />
      <div className="container-fluid">
        <div className="row">
          <div className="col-12">
            <GrievanceHeaderInfo {...headerInfoProps} />
          </div>
        </div>

        <div className="row g-3">
          <div className="col-12">
            {/* Complaint Details */}
            <ComplaintDetails details={complaintDetailsProps} readonly={isReadonly} />
          </div>

          <div className="col-12">

            {/* Resolution Provided */}
            {true && (
              <ResolutionBlock
                title="Previous Resolution (By Compliance Officer)"
                resolutionText={complaintData?.resolutionRemark}
                description="The complaint has been escalated to you for review and resolution."
              />
            )}
            {/* {true && (
              <ResolutionBlock
                title="Resolution Provided"
                description="We have investigated the issue and found that there is an excess interest charges has been debited due to system error. the extra amount has been reversed and credited back to your account on 27-09-2025."
                resolvedBy="Grievance Officer"
                resolutionDate="27-09-2025, 10:15 AM"
              />
            )} */}

            {/* Comment */}
            <AppForm onSubmit={handleSubmit} className="mb-4">
              <AppInput
                name="resolutionRemark"
                label="Resolution Remarks"
                type="textarea"
                placeholder="Please enter" 
                required
              ></AppInput>
              {isReadonly || complaintData?.status === _enum.COMPLAINT_STATUS_MAP.CLOSED ? (
                <div className="d-flex align-items-center justify-content-end">
                  <button
                    type="button"
                    className="btn btn-primary-lite me-3"
                    onClick={() => navigate(backLink)}
                  >
                    Close
                  </button>
                </div>
              ) : (
                <div className="d-flex align-items-center justify-content-end">
                  <button
                    type="button"
                    className="btn btn-primary-lite me-3"
                    onClick={handleCloseResolution}
                  >
                    Close Resolution
                  </button>
                  <button type="submit" className="btn btn-primary">
                    Submit Resolution
                  </button>
                </div>
              )}
            </AppForm>

            {/* Activity Logs */}
            <ActivityLogs logs={mappedLogs} />
          </div>
        </div>
      </div>
    </>
  );
};

export default constore(EscalatedComplaintsView);
